module.exports = __webpack_public_path__ + "img/Stemness-PRCA_SpatialResearch.329975be.png";